"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountTradeType = exports.USD_COINS = exports.PRODUCT_TYPE = exports.ExchangeSymbolType = void 0;
/**
 * 交易对类型
 */
var ExchangeSymbolType;
(function (ExchangeSymbolType) {
    /**
     * 现货
     */
    ExchangeSymbolType["spot"] = "spot";
    /**
     * 杠杆代币
     */
    ExchangeSymbolType["leveraged_coin"] = "leveraged_coin";
    /**
     * 币安U本位合约
     */
    ExchangeSymbolType["swap_binance"] = "swap_binance";
    /**
     * 币安币本位合约
     */
    ExchangeSymbolType["cm_swap_binance"] = "cm_swap_binance";
    /**
     * 永续合约
     */
    ExchangeSymbolType["future_perpetual"] = "future_perpetual";
    /**
     * 未定义
     */
    ExchangeSymbolType["unknown"] = "unknown";
})(ExchangeSymbolType || (exports.ExchangeSymbolType = ExchangeSymbolType = {}));
var PRODUCT_TYPE;
(function (PRODUCT_TYPE) {
    // BU = "BitUniverse",
    // PIONEX = "Pionex",
    // PIONEX_LITE = "PionexLite",
    PRODUCT_TYPE["PIONEX"] = "pionex";
    PRODUCT_TYPE["BU"] = "bituniverse";
    PRODUCT_TYPE["PICOL"] = "picol";
    PRODUCT_TYPE["PIONEX_COL"] = "pionex_col";
    PRODUCT_TYPE["PIONEX_DEV"] = "pionex.dev";
    PRODUCT_TYPE["PICOL_TW"] = "picol.tw";
    PRODUCT_TYPE["PIONEX_LITE"] = "pionexlite";
    PRODUCT_TYPE["PIONEX_CN"] = "pionex.cn";
    PRODUCT_TYPE["PIONEX_SG"] = "pionex.sg";
    PRODUCT_TYPE["PIONEX_US"] = "pionex.us";
    PRODUCT_TYPE["PIONEX_US_V2"] = "pionex.us.v2";
    PRODUCT_TYPE["WEBOT"] = "webot";
    PRODUCT_TYPE["PIONEX_KOL"] = "pionex.kol";
})(PRODUCT_TYPE || (exports.PRODUCT_TYPE = PRODUCT_TYPE = {}));
exports.USD_COINS = ["BUSD", "USDC"];
var AccountTradeType;
(function (AccountTradeType) {
    /** 机器人账户 */
    AccountTradeType["bot"] = "bot";
    /** 交易员账户 */
    AccountTradeType["trader"] = "trader";
})(AccountTradeType || (exports.AccountTradeType = AccountTradeType = {}));
